import { AtIcon } from "@csc-dashboard/components-library";

const PANEL_TITLE = "Panel del agente";

interface HandleButtonProps {
  disabled?: boolean;
  onClick: () => void;
}
export const HandleButton = ({ onClick, disabled }: HandleButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="bg-primary-500 z-20 fixed top-1/2 -translate-y-1/2 right-0 
    box-border shadow-mid-down text-white hover:pr-6 
    transition-all duration-300 cursor-pointer rounded-tl-lg rounded-bl-lg "
    >
      <div className="flex flex-col items-center justify-center gap-2 h-[96px] w-[96px]">
        <AtIcon name="dashboard-outlined" />
        <p className="text-sm font-normal text-center">{PANEL_TITLE}</p>
      </div>
    </button>
  );
};
